import { render } from "./ProductBarcode.vue?vue&type=template&id=79d0adcc"
import script from "./ProductBarcode.vue?vue&type=script&lang=js"
export * from "./ProductBarcode.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__